module.exports = __webpack_public_path__ + "img/popup.0facb407.webp";